import { AxiosError } from 'axios';
import { useQuery, UseQueryOptions } from 'react-query';
import { ProfessionalWithPractice } from '@aldebaran/common/types';
import { client } from '../util/client';

export const useProfessional = (
  slug: string | undefined | null,
  options: UseQueryOptions<ProfessionalWithPractice, AxiosError> = {},
) => {
  return useQuery<ProfessionalWithPractice, AxiosError>(
    ['professional', slug],
    async () =>
      client(`/user/public/${slug}`).then((response) => response?.data),
    {
      enabled: !!slug,
      retry: false,
      ...options,
    },
  );
};
